export default "__VITE_ASSET__DZFKU1Tk__"